import { SORT_TYPE } from './sortType';

export const ORDER_TYPE = {
  ASC: 'asc',
  DESC: 'desc',
};

export const CHANNEL_SORT_NAME = {
  CREATED: 'created',
  EDITED: 'edited',
  PUBLISHED: 'published',
  COMMENTS: 'comments',
  SHARES: 'shares',
  REBUZZES: 'rebuzzes',
  TOP: 'top',
  NEW: 'new',
  GENERAL: 'general',
  USE_CASES: 'useCases',
  THREAD: 'thread',
};

export const TIMELINE_SORT_NAME = {
  TOP: 'top',
  NEW: 'new',
  GENERAL: 'general',
  USE_CASES: 'useCases',
  THREAD: 'thread',
};

export const TIMELINE_SORT_OPTIONS = [
  { name: TIMELINE_SORT_NAME.TOP },
  { name: TIMELINE_SORT_NAME.NEW },
  { name: TIMELINE_SORT_NAME.GENERAL },
  { name: TIMELINE_SORT_NAME.USE_CASES },
  { name: TIMELINE_SORT_NAME.THREAD },
];

export const CHANNEL_SORT_OPTIONS = [
  { name: CHANNEL_SORT_NAME.CREATED, sortType: SORT_TYPE.AGE },
  { name: CHANNEL_SORT_NAME.EDITED, sortType: SORT_TYPE.AGE },
  { name: CHANNEL_SORT_NAME.PUBLISHED, sortType: SORT_TYPE.AGE },
  { name: CHANNEL_SORT_NAME.COMMENTS, sortType: SORT_TYPE.QUANTITY },
  { name: CHANNEL_SORT_NAME.SHARES, sortType: SORT_TYPE.QUANTITY },
  { name: CHANNEL_SORT_NAME.REBUZZES, sortType: SORT_TYPE.QUANTITY },
];
